module.exports = __webpack_public_path__ + "img/002.943d7721.jpg";